/**
 * Para onde o clique num aviso do sino leva.
 *
 * Os avisos do relato (ADR-084) abrem o chamado na aba Atendimento. Os do
 * Progresso (22/10/2026) abrem a aba Progresso da iniciativa, onde mora o
 * pedido da equipe ou a nova publicação.
 */

const TIPOS_DO_PROGRESSO = ['progresso_pedido', 'progresso_cobranca', 'progresso_publicado']

export function ehAvisoDoProgresso(aviso) {
  return TIPOS_DO_PROGRESSO.includes(aviso?.type)
}

/** O caminho do aviso, ou `null` quando ele não tem para onde levar. */
export function destinoDoAviso(aviso) {
  if (!aviso?.initiative_id) return null
  if (ehAvisoDoProgresso(aviso)) return `/iniciativa/${aviso.initiative_id}/progresso`
  return `/iniciativa/${aviso.initiative_id}/atendimento?chamado=relato:${aviso.bug_report_id}`
}
